<template>
   <div class="flex items-center justify-start gap-2">
       <input
          class="mt-0 mr-1 focus:ring-0 checked:text-won-green ring-0 checked:border-none"
          type="checkbox"
          :id="id"
          :value="value"
          v-model="isChecked"
        />
      <label :for="id" class="won-color-gray text-[16px] cursor-pointer leading-[20px]">
        {{ label }}
      </label>
   </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    id: String,
    label: String,
    value: {
      type: String,
      default: ""
    },
    modelValue: Array | Boolean
  },
  emits: ['update:modelValue'],
  setup(props) {
    const isChecked = ref(props.modelValue);

    return {
      isChecked
    };
  },
  watch: {
    isChecked(newValue) {
      this.$emit('update:modelValue', newValue);
    }
  }
};
</script>
